<div *ngIf="bookingStudentService.studentForm" [formGroup]="bookingStudentService.studentForm"
  class="student-form-container">
  <div class="student-contact-section">
    <div class="title-container">
      <h3 class="title">
        Student
      </h3>
    </div>
    <div class="list-item-container">
      <div class="list-item">
        <p>
          First name
        </p>
        <input pInputText formControlName="firstName" class="person-name-input">
      </div>
      <div class="list-item">
        <p>
          Last name
        </p>
        <input pInputText formControlName="lastName" class="person-name-input">
      </div>
      <div class="list-item">
        <p>
          Student language
        </p>
        <p-dropdown placeholder="-Select Language-" [options]="bookingService.languages" optionLabel="name"
          formControlName="language">
        </p-dropdown>
      </div>
      <div class="list-item">
        <p>
          Gender
        </p>
        <p-dropdown placeholder="-Select Gender-" [options]="bookingService.genders" optionLabel="name"
          formControlName="gender">
          <ng-template pTemplate="item" let-item>
            {{item.name | titlecase}}
          </ng-template>
          <ng-template pTemplate="selectedItem" let-item>
            {{item.name | titlecase}}
          </ng-template>
        </p-dropdown>
      </div>
      <div class="list-item">
        <p>
          Birthdate
        </p>
        <p-calendar [monthNavigator]="true" [yearRange]="yearRange" [yearNavigator]="true"
          (onSelect)="bookingService.calculateAgeAtStartDate()" formControlName="birthDay" dateFormat="dd/mm/yy" [showIcon]="true">
        </p-calendar>
      </div>
      <div class="list-item">
        <span>
          Age at departure:
        </span>
        <span *ngIf="bookingService.booking.ageAtStartDate">
          {{bookingService.booking.ageAtStartDate}}
        </span>
      </div>
      <div class="list-item">
        <p>
          Nationality
        </p>
        <p-dropdown placeholder="-Select Nationality-" [options]="bookingService.countryList" optionLabel="name"
          [filter]="true" filterBy="name" formControlName="nationality"></p-dropdown>
      </div>
      <div class="list-item">
        <p>
          Mother Language
        </p>
        <p-dropdown dataKey="id" placeholder="-Select Language-" [options]="bookingService.motherLanguages"
          optionLabel="name" [filter]="true" filterBy="name" formControlName="motherLanguage"></p-dropdown>
      </div>
    </div>
  </div>
  <div class="student-preferences-section">
    <div class="title-container">
      <h3 class="title">
        Preferences
      </h3>
    </div>
    <div class="list-item-container">
      <div class="list-item">
        <p>
          Allergies
        </p>
        <input pInputText formControlName="allergies" class="allergies-input">
      </div>
      <div class="list-item">
        <p>
          Special diet
        </p>
        <input pInputText formControlName="specialDiet" class="allergies-input">
      </div>
      <div class="list-item">
        <p>
          Hobbies
        </p>
        <input pInputText formControlName="hobbies" class="hobbies-input">
      </div>
      <div class="list-item">
        <p>
          Smoking ok
        </p>
        <p-dropdown [options]="bookingService.responseList" formControlName="smokingOk"></p-dropdown>
      </div>
      <div class="list-item">
        <p>
          Kids ok
        </p>
        <p-dropdown [options]="bookingService.responseList" formControlName="kidsOk"></p-dropdown>
      </div>
      <div class="list-item">
        <p>
          Pets ok
        </p>
        <p-dropdown [options]="bookingService.responseList" formControlName="petsOk"></p-dropdown>
      </div>
      <div class="list-item">
        <p>
          Other preferences
        </p>
        <textarea pInputTextarea formControlName="otherPreference" class="student-other-preferences"></textarea>
      </div>
    </div>
  </div>
  <div class="student-contact-information-section">
    <div class="title-container">
      <h3 class="title">
        Primary Contact
      </h3>
    </div>
    <div class="list-item-container">
      <div>
        Type
      </div>
      <p-dropdown placeholder="select type" [options]="bookingStudentService.studentContactTypes" optionLabel="name"
        formControlName="primaryContactType"></p-dropdown>
      <div class="list-item">
        <p>
          Mobile
        </p>
        <input pInputText formControlName="mobile">
      </div>
      <div class="list-item">
        <p>
          Phone
        </p>
        <input pInputText formControlName="phoneNumber">
      </div>
      <div class="list-item">
        <p>
          Email
        </p>
        <input pInputText formControlName="email" class="email-input">
      </div>
      <div [formGroup]="contact | formGroup"
        *ngFor="let contact of studentContactFormArray; let i = index"
        class="student-contact-form">
        <p>
          Contact {{i+1}}
        </p>
        <div>
          <p>
            Type
          </p>
          <p-dropdown placeholder="select type" [options]="bookingStudentService.studentContactTypes" optionLabel="name"
            formControlName="type"></p-dropdown>
          <p-button icon="pi pi-trash" (onClick)="bookingStudentService.deleteStudentContact(contact, i)"
            styleClass="p-button-danger"></p-button>
        </div>
        <div>
          <p>
            Name
          </p>
          <input pInputText formControlName="name" class="email-input">
        </div>
        <div>
          <p>
            Email
          </p>
          <input pInputText formControlName="email" class="email-input">
        </div>
        <div>
          <p>
            Mobile
          </p>
          <input pInputText formControlName="mobileNumber">
        </div>
        <div>
          <p>
            Phone
          </p>
          <input pInputText formControlName="phoneNumber">
        </div>
      </div>
      <p-button label="Add" icon="pi pi-plus" (onClick)="bookingStudentService.insertStudentContactForm()"
        id="add-student-contact-button"></p-button>
    </div>
  </div>
  <div class="student-address-section">
    <div class="title-container">
      <h3 class="title">
        Address
      </h3>
    </div>
    <div class="list-item-container">
      <div class="list-item">
        <p>
          Address
        </p>
        <input pInputText formControlName="address" class="address-input">
      </div>
      <div class="list-item">
        <p>
          Post code
        </p>
        <input pInputText formControlName="postCode">
      </div>
      <div class="list-item">
        <p>
          City
        </p>
        <input pInputText formControlName="city">
      </div>
      <div class="list-item">
        <p>
          Country
        </p>
        <p-dropdown placeholder="-Select Country-" [options]="bookingService.countryList" optionLabel="name"
          formControlName="country" [filter]="true" filterBy="name"></p-dropdown>
      </div>
    </div>
    <div>
      <div class="title-container">
        <h3 class="title">
          Secondary Address
        </h3>
      </div>
      <div class="list-item-container">
        <div class="list-item">
          <p>
            Address
          </p>
          <input pInputText formControlName="secondaryAddress" class="address-input">
        </div>
        <div class="list-item">
          <p>
            Post code
          </p>
          <input pInputText formControlName="secondaryPostCode">
        </div>
        <div class="list-item">
          <p>
            City
          </p>
          <input pInputText formControlName="secondaryCity">
        </div>
        <div class="list-item">
          <p>
            Country
          </p>
          <p-dropdown placeholder="-Select Country-" [options]="bookingService.countryList" optionLabel="name"
            formControlName="secondaryCountry" [filter]="true" filterBy="name"></p-dropdown>
        </div>
      </div>
    </div>
  </div>
  <div class="student-comment-section">
    <div class="title-container">
      <h3 class="title">
        Comments
      </h3>
    </div>
    <div class="list-item-container">
      <div [formGroup]="bookingStudentService.commentForm" class="student-comment-button-container"
        *ngIf="bookingStudentService.commentForm">
        <textarea class="student-comment-new" pInputTextarea formControlName="body"></textarea>
        <button
          [disabled]="bookingStudentService.commentForm.value.body == null || bookingStudentService.commentForm.value.body == ''"
          pButton (click)="bookingStudentService.postStudentComment()" type="button" label="Submit"
          class="p-button-success"></button>
      </div>
      <div *ngIf="bookingService.booking.student" class="student-comments-container">
        <div *ngFor="let comment of bookingService.booking.student.studentComments">
          <div class="student-comment-body">
            {{comment.body}}
          </div>
          <div class="student-comment-detail">
            By {{comment.createdBy!.name}}, on {{comment.created!.toDate() | date: 'dd/MM/yyyy \'at\' HH:mm'}}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>